import React from 'react';
import styled from 'astroturf/react';
import { Icon } from 'js/design_system/Icon';
import { Body } from 'js/design_system/Body';
import ThumbUpFilled from 'js/design_system/icons/thumb_up_filled.svg';
import BookmarkFilled from 'js/design_system/icons/bookmark_filled.svg';
import ImpressionWatcher, {
  Props as ImpressionProps,
} from 'js/utils/impressions/ImpressionWatcher';
import _Wrapper from "NewsInteractionBar-Wrapper.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/CoreX/News/NewsInteractionBar.tsx?styleId=Wrapper";
import _InteractionButtonWrapper from "NewsInteractionBar-InteractionButtonWrapper.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/CoreX/News/NewsInteractionBar.tsx?styleId=InteractionButtonWrapper";
import _InteractionButton from "NewsInteractionBar-InteractionButton.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/CoreX/News/NewsInteractionBar.tsx?styleId=InteractionButton";
import _InteractionButtonDisabled from "NewsInteractionBar-InteractionButtonDisabled.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/CoreX/News/NewsInteractionBar.tsx?styleId=InteractionButtonDisabled";
import _IconWrapper from "NewsInteractionBar-IconWrapper.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/CoreX/News/NewsInteractionBar.tsx?styleId=IconWrapper";
import _InteractionCount from "NewsInteractionBar-InteractionCount.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/CoreX/News/NewsInteractionBar.tsx?styleId=InteractionCount";
import _DenseInteractionCount from "NewsInteractionBar-DenseInteractionCount.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/CoreX/News/NewsInteractionBar.tsx?styleId=DenseInteractionCount";
import _CountSpacer from "NewsInteractionBar-CountSpacer.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/CoreX/News/NewsInteractionBar.tsx?styleId=CountSpacer";
import _Spacer from "NewsInteractionBar-Spacer.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/CoreX/News/NewsInteractionBar.tsx?styleId=Spacer";
import _VariantSpacer from "NewsInteractionBar-VariantSpacer.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/CoreX/News/NewsInteractionBar.tsx?styleId=VariantSpacer";


const Wrapper = /*#__PURE__*/styled("div", null, {
  displayName: "Wrapper",
  styles: _Wrapper
});

const InteractionButtonWrapper = /*#__PURE__*/styled("div", null, {
  displayName: "InteractionButtonWrapper",
  styles: _InteractionButtonWrapper
});

const InteractionButton = /*#__PURE__*/styled("button", null, {
  displayName: "InteractionButton",
  styles: _InteractionButton
});

const InteractionButtonDisabled = /*#__PURE__*/styled("button", null, {
  displayName: "InteractionButtonDisabled",
  styles: _InteractionButtonDisabled
});

const IconWrapper = /*#__PURE__*/styled("div", null, {
  displayName: "IconWrapper",
  styles: _IconWrapper
});

const InteractionCount = /*#__PURE__*/styled(Body, null, {
  displayName: "InteractionCount",
  styles: _InteractionCount
});

const DenseInteractionCount = /*#__PURE__*/styled(Body, null, {
  displayName: "DenseInteractionCount",
  styles: _DenseInteractionCount
});

const CountSpacer = /*#__PURE__*/styled("div", null, {
  displayName: "CountSpacer",
  styles: _CountSpacer
});

const Spacer = /*#__PURE__*/styled("div", null, {
  displayName: "Spacer",
  styles: _Spacer
});

export const NewsInteractionBar = ({
  isLiked,
  numLikes,
  onLike,
  onUnlike,
  showBookmark = true,
  isBookmarkEnabled = true,
  isBookmarked,
  numBookmarks,
  onBookmark,
  onUnbookmark,
  numComments,
  onAddComment,
  impressionPropsGen,
  variant = 'default',
}: {
  isLiked: boolean;
  numLikes: number;
  onLike?: () => void;
  onUnlike?: () => void;
  showBookmark?: boolean;
  isBookmarkEnabled?: boolean;
  isBookmarked: boolean;
  numBookmarks: number;
  onBookmark?: () => void;
  onUnbookmark?: () => void;
  numComments: number;
  onAddComment?: () => void;
  impressionPropsGen: (clickTarget?: string) => ImpressionProps;
  variant?: 'default' | 'dense';
}) => {
  const VariantSpacer = variant === 'default' ? Spacer : /*#__PURE__*/styled("div", null, {
  displayName: "VariantSpacer",
  styles: _VariantSpacer
});
  const InteractionCountComponent =
    variant === 'default' ? InteractionCount : DenseInteractionCount;
  const size = variant === 'default' ? 'md' : 'sm';

  const formatNumber = (num: number): string => {
    if (!num) {
      return '0';
    }
    if (num >= 1000000) {
      return `${(num / 1000000).toFixed(1).replace(/\.0$/, '')}M`;
    }
    if (num >= 1000) {
      return `${(num / 1000).toFixed(1).replace(/\.0$/, '')}K`;
    }
    return num.toString();
  };

  const formattedNumLikes =
    variant === 'dense' ? formatNumber(numLikes) : numLikes;
  const formattedNumComments =
    variant === 'dense' ? formatNumber(numComments) : numComments;
  const formattedNumBookmarks =
    variant === 'dense' ? formatNumber(numBookmarks) : numBookmarks;

  return (
    <Wrapper variant={variant}>
      <VariantSpacer />
      <VariantSpacer />
      <InteractionButtonWrapper variant={variant}>
        <ImpressionWatcher {...impressionPropsGen('like-button')}>
          <InteractionButton
            onClick={isLiked ? onUnlike : onLike}
            data-coachmark-step="news-feed-like"
          >
            <IconWrapper>
              {isLiked ? <ThumbUpFilled size={20} /> : <Icon name="thumb_up" />}
            </IconWrapper>
          </InteractionButton>
        </ImpressionWatcher>
        {numLikes > 0 && (
          <InteractionCountComponent size={size}>
            {formattedNumLikes}
          </InteractionCountComponent>
        )}
        {numLikes === 0 && variant === 'dense' && <CountSpacer />}
      </InteractionButtonWrapper>
      <VariantSpacer />
      <InteractionButtonWrapper variant={variant}>
        <ImpressionWatcher {...impressionPropsGen('comment-button')}>
          <InteractionButton
            onClick={onAddComment}
            data-coachmark-step="news-feed-comment"
          >
            <IconWrapper>
              <Icon name="chat_bubble" />
            </IconWrapper>
          </InteractionButton>
        </ImpressionWatcher>
        {numComments > 0 && (
          <InteractionCountComponent size={size}>
            {formattedNumComments}
          </InteractionCountComponent>
        )}
        {numComments === 0 && variant === 'dense' && <CountSpacer />}
      </InteractionButtonWrapper>
      <VariantSpacer />
      {showBookmark && (
        <InteractionButtonWrapper variant={variant}>
          {isBookmarkEnabled ? (
            <ImpressionWatcher {...impressionPropsGen('bookmark-button')}>
              <InteractionButton
                onClick={isBookmarked ? onUnbookmark : onBookmark}
                data-coachmark-step="news-feed-bookmark"
              >
                <IconWrapper>
                  {isBookmarked ? (
                    <BookmarkFilled size={20} />
                  ) : (
                    <Icon name="bookmark" />
                  )}
                </IconWrapper>
              </InteractionButton>
            </ImpressionWatcher>
          ) : (
            <InteractionButtonDisabled disabled={true}>
              <Icon name="bookmark" />
            </InteractionButtonDisabled>
          )}
          {numBookmarks > 0 && (
            <InteractionCountComponent size={size}>
              {formattedNumBookmarks}
            </InteractionCountComponent>
          )}
          {numBookmarks === 0 && variant === 'dense' && <CountSpacer />}
        </InteractionButtonWrapper>
      )}
      {showBookmark && <VariantSpacer />}
      <VariantSpacer />
    </Wrapper>
  );
};
